module.exports = __webpack_public_path__ + "static/prospect-park-cover-image-901669fc47661e653fa0cbc81caa9d6c.jpg";